export default "__VITE_ASSET__d362fff6__"